import { FeatureGates, useFeatureGate } from '@services/statsig';

import { useGetPatientEligibilityQuery } from '../store/api';
import { apiToSnapshot, type EligibilitySnapshot } from '../types';

/**
 * Lightweight hook that returns the eligibility snapshot for a patient.
 * Returns undefined when the feature is disabled, no patient ID is provided,
 * or no eligibility check has been run yet.
 *
 * Uses RTK Query caching — duplicate calls for the same patient ID
 * share a single network request.
 */
export function usePatientEligibilityStatus(
  patientId?: string | null,
): EligibilitySnapshot | undefined {
  const isEnabled = useFeatureGate(FeatureGates.ELIGIBILITY_CHECKS);

  const { data } = useGetPatientEligibilityQuery(
    { patientId: patientId ?? '' },
    { skip: !isEnabled || !patientId },
  );

  return data ? apiToSnapshot(data) : undefined;
}
